import { Box } from '@material-ui/core';

import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { useTranslation } from '@/components/shared/hooks/useTranslation';

interface CheckoutSessionCreationCardProps {
  titleIconName: string;
  titleTextId: string;
  descriptionTextId: string;
  buttonIconName: string;
  buttonLabelTextId: string;
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export const CheckoutSessionCreationCard = ({
  titleIconName,
  titleTextId,
  descriptionTextId,
  buttonIconName,
  buttonLabelTextId,
  onClick,
  loading,
  disabled = false,
}: CheckoutSessionCreationCardProps) => {
  const { getTextIdTranslation } = useTranslation();

  return (
    <CustomPaper
      fill="paper"
      boxProps={{
        height: '100%',
      }}
      style={{
        padding: 24,
        minHeight: '240px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: 'calc(100% - 42px)',
      }}
    >
      <Box flexGrow={1}>
        <Font variant="h4" color="title">
          <strong>
            <Box display={'inline-flex'} alignItems={'center'} gridGap={10} marginBottom={3}>
              <Icon size={20}>{titleIconName}</Icon> {getTextIdTranslation(titleTextId)}
            </Box>
          </strong>
        </Font>
        <Box marginBottom={3}>
          <Font variant="body2" color="textPrimary">
            {getTextIdTranslation(descriptionTextId)}
          </Font>
        </Box>
      </Box>
      <StandardButton
        loading={loading}
        main
        onClick={onClick}
        endIcon={<Icon>{buttonIconName}</Icon>}
        disabled={disabled}
      >
        {getTextIdTranslation(buttonLabelTextId)}
      </StandardButton>
    </CustomPaper>
  );
};
